import { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  createStaffAsync,
  editStaffAsync,
  fetchStaffsAsync,
  removeStaffAsync,
} from "../../features/services/staff/StaffSlice";
import { Staff } from "../../features/services/staff/Staff.type";

const useStaffs = () => {
  const dispatch = useAppDispatch();
  const staffs = useAppSelector((state) => state.staff.staffs);
  const error = useAppSelector((state) => state.staff.error);
  const loading = useAppSelector((state) => state.staff.status);

  const createStaff = (staff: Staff) => dispatch(createStaffAsync(staff));
  const editStaff = (staff: Staff) => dispatch(editStaffAsync(staff));
  const removeStaff = (staffId: number) => dispatch(removeStaffAsync(staffId));

  useEffect(() => {
    dispatch(fetchStaffsAsync());
  }, [dispatch]);

  const memoizedStaffs = useMemo(() => staffs, [staffs]);

  return {
    staffs: memoizedStaffs,
    error,
    loading,
    createStaff,
    editStaff,
    removeStaff,
  };
};

export default useStaffs;
